
export enum BasysInternalPaymentMethodType {
  cardToken = 'card_token',
  card = 'card',
}
